<template>
  <div>
    <ClientList
      v-if="view === 'list'"
      :clients="listData"
      @back="backToCrm"
    />
    <CRow v-if="view === 'crm'">
      <CCol md="12" lg="12" sm="12" xs="12" class="float-right mb-2">
        <button @click="mtdBack" type="button" class="btn btn-sm text-white float-right" style="background: #E46666">
          <i class="fas fa-hand-point-left"></i> Retroceder
        </button>
      </CCol>
      <CCol lg="2" md="4" sm="6" xs="12">
        <CCard accent-color="primary" title="Total de clientes registrados en el sistema">
          <CCardHeader>Total Clientes</CCardHeader>
          <CCardBody class="kpi-card total">
            <div class="kpi-value">{{ kpis.total }}</div>
            <div class="kpi-sub"><span class="positivo">↑ +{{ kpis.new_this_month }}</span> este mes</div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol lg="2" md="4" sm="6" xs="12">
        <CCard accent-color="success accent" title="Son los clientes que han tenido contacto reciente en < 20 dias">
          <CCardHeader>Activos</CCardHeader>
          <CCardBody class="kpi-card active">
            <div class="kpi-value">{{ kpis.active }}</div>
            <div class="kpi-sub"><span class="positivo">{{ kpis.active_percent }}%</span> del total</div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol lg="2" md="4" sm="6" xs="12">
        <CCard accent-color="warning" title="Son los clientes que de 20 a 45 dias no vienen">
          <CCardHeader>En Riesgo</CCardHeader>
          <CCardBody class="kpi-card risk">
            <div class="kpi-value">{{ kpis.risk }}</div>
            <div class="kpi-sub">
              <span :class="kpis.risk_diff >= 0 ? 'negativo' : 'positivo'">
                {{ kpis.risk_diff >= 0 ? '↑ +' : '↓ ' }}{{ kpis.risk_diff }}
              </span>
              vs semana pasada
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol lg="2" md="4" sm="6" xs="12">
        <CCard accent-color="danger" title="Son clientes que llevan mucho tiempo sin regresar > 45 días">
          <CCardHeader>Perdidos</CCardHeader>
          <CCardBody class="kpi-card lost">
            <div class="kpi-value">{{ kpis.lost }}</div>
            <div class="kpi-sub"><span class="dn">↓ -{{ kpis.recovered }}</span> recuperados</div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol lg="2" md="4" sm="6" xs="12">
        <CCard accent-color="secondary accent" title="Le muestra cada cuánto tiempo, en promedio, sus clientes regresan">
          <CCardHeader>Días Sin Visita</CCardHeader>
          <CCardBody class="kpi-card days">
            <div class="kpi-value">{{ kpis.avg_days }}</div>
            <div class="kpi-sub">promedio general</div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol lg="2" md="4" sm="6" xs="12">
        <CCard accent-color="info accent" title="Le indica cuántos clientes debería contactar hoy.">
          <CCardHeader>Seguimiento Hoy</CCardHeader>
          <CCardBody class="kpi-card today">
            <div class="kpi-value">{{ kpis.follow_today }}</div>
            <div class="kpi-sub">clientes pendientes</div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="12" xl="12">
        <CTableWrapperVisualizar :items="data_baja" :fields="fields_baja" hover :striped="true" :border="true" small fixed
          caption="Clientes activos" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'"
          @showList="openList">
        </CTableWrapperVisualizar>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="12" xl="12">
        <CTableWrapperVisualizar :items="data_media" :fields="fields_media" hover :striped="true" :border="true" small
          fixed caption="Contactar Esta Semana" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'"
          @showList="openList">
        </CTableWrapperVisualizar>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="6" xl="12">
        <CTableWrapperVisualizar :items="data_alta" :fields="fields_alta" hover :striped="true" :border="true" small fixed
          caption="Clientes perdidos" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'"
          @showList="openList">
        </CTableWrapperVisualizar>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="6" xl="12">
        <CTableWrapper :items="rankings" :fields="ranking" hover :striped="true" :border="true" small fixed
          caption="Ranking" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'">
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
  
</template>
<script>
const fields_baja = [
  { key: "index", label: "Cita", _style: "width:5%;" },
  { key: "name_client", label: "Cliente", _style: "width:5%;" },
  { key: "ultimo_contacto", label: "Ultimo Contacto", _style: "width:5%;" },
  { key: "services", label: "Servicios", _style: "width:10%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];
const fields_media = [
  { key: "index", label: "Cita", _style: "width:5%;" },
  { key: "name_client", label: "Cliente", _style: "width:5%;" },
  { key: "ultimo_contacto", label: "Ultimo Contacto", _style: "width:5%;" },
  { key: "services", label: "Servicios", _style: "width:10%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];
const fields_alta = [
  { key: "index", label: "Cita", _style: "width:5%;" },
  { key: "name_client", label: "Cliente", _style: "width:5%;" },
  { key: "ultimo_contacto", label: "Ultimo Contacto", _style: "width:5%;" },
  { key: "services", label: "Servicios", _style: "width:10%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];
const ranking = [
  { key: "name_client", label: "Cliente", _style: "width:5%;" },
  { key: "visits_count", label: "Cantidad de visitas", _style: "width:5%;" },

];

import CTableWrapper from "../shared/datatable/Table.vue";
import CTableWrapperVisualizar from "../shared/datatable/TableVisualizar.vue";
import ClientList from "./ClientsList.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CTableWrapper,
    CTableWrapperVisualizar,
    ClientList
  },
  data() {
    return {
      view: "crm", // crm | list
      listData: [],
      prefix: "report",
      fields_baja,
      fields_media,
      fields_alta,
      ranking,
      today: moment().format("YYYY-MM-DD"),
      data_baja: [],
      data_media: [],
      data_alta: [],
      rankings: [],
      kpis: {
        total: 0,
        new_this_month: 0,
        active: 0,
        active_percent: 0,
        risk: 0,
        risk_diff: 0,
        lost: 0,
        recovered: 0,
        avg_days: 0,
        follow_today: 0
      }
    }
  },
  created() {
    moment.locale("es");
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack() {
      this.$emit('mtdBack')
    },
    openList(data) {
      this.listData = data
      this.view = "list"
    },
    backToCrm() {
      this.view = "crm"
    },
    mtd_data: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/byCrmClients",
        token: this.$store.getters.get__token,
        params: {
          campu_id: this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {

            const formatServices = (data) => {
              return data.map(c => {
                return {
                  ...c,
                  services: c.services
                    ? c.services.map(s => s.name_service).join(", ")
                    : ""
                }
              })
            }
            this.data_baja = formatServices(response.data.table_baja);
            this.data_media = formatServices(response.data.table_media);
            this.data_alta = formatServices(response.data.table_alta);

            this.rankings = response.data.ranking_visitas;
            this.kpis = response.data.kpis;
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
  },
}
</script>
<style lang="scss" scoped>
.kpi-card {
  --accent: #00e5a0;
  --accent2: #ff6b35;
  --accent3: #7b5cf0;
  --warn: #ffb830;
  --danger: #ff4466;
  --text: #e8e8f0;
  --muted: #6b6b85;
}

.kpi-value {
  font-family: 'Space Mono', monospace;
  font-size: 36px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 8px;
}

.kpi-card.total .kpi-value {
  color: var(--accent3);
}

.kpi-card.active .kpi-value {
  color: var(--accent);
}

.kpi-card.risk .kpi-value {
  color: var(--warn);
}

.kpi-card.lost .kpi-value {
  color: var(--danger);
}

.kpi-card.days .kpi-value {
  color: var(--accent2);
}

.kpi-card.today .kpi-value {
  color: #00c4ff;
}

.kpi-sub {
  font-size: 11px;
  color: var(--muted);
}

.kpi-sub .up {
  color: var(--danger);
}

.kpi-sub .dn {
  color: var(--accent);
}

.kpi-sub .positivo{
  color: var(--accent);
}

.kpi-sub .negativo {
  color: var(--danger);
}
</style>
